import styled from 'styled-components';

import ContentMedia from 'components/ContentMedia/ContentMedia';
import RichTextBase from 'components/RichText/RichText';
import {
  WidthBlockWrapper,
  WidthBlockWrapperProps,
} from 'components/WidthWrapper';
import { setTypography } from 'utils/styles/mixins';

interface WrapperProps extends WidthBlockWrapperProps {
  alignment: 'start' | 'end' | 'center';
}

export const Wrapper = styled(WidthBlockWrapper)<WrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 40px;

  align-items: start;
  justify-content: ${({ alignment }) => `${alignment || 'start'}`};
`;

export const MultisectionContentMedia = styled(ContentMedia)`
  height: auto;
`;

export const RichText = styled(RichTextBase)`
  h1 {
    ${({ theme: { locale } }) => setTypography('heading1', locale)}
  }
  h2 {
    ${({ theme: { locale } }) => setTypography('heading2', locale)}
  }
  h3 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)}
  }
  h4 {
    ${({ theme: { locale } }) => setTypography('heading4', locale)}
  }
  h5 {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
  }

  ${({ theme: { locale } }) => setTypography('body', locale)}
`;
